import type { FaireProductEntity } from "../../entity_types/product";

export const p_5zppv4c8pw: FaireProductEntity = {
  token: "p_5zppv4c8pw",
  type: "product",
  name: "Ruffled Hugger Crew Socks  (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/25f307bf397c2a5a4482601bdae31ce852b46ade6531d8b7c3079a6a83888d45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/335e22fffbb9481a5bea1f1aa75776347a5ef26a8dc4ad5dfefde89c45ca125e.jpeg",
    "https://cdn.faire.com/fastly/fb91490fa93fc8cc8c7719f00e4d83530343601174b0e09766dda1125e83160a.jpeg",
    "https://cdn.faire.com/fastly/9c947e02c1e044b8ad762152d61b3f31e27dca9506b44f82aec76b815896c24d.jpeg",
    "https://cdn.faire.com/fastly/ec2708342653065450d4ace68d6bd2234c861243ca48aac2165ffd87173bd812.jpeg",
    "https://cdn.faire.com/fastly/9ce96a0343313b029b0eefd152c51f53cc2d37fc72c83173abb90250f36eed2a.jpeg",
    "https://cdn.faire.com/fastly/7ec7430ad8b381f122aa5b5d753f6a2e4933ef5a2345a099a416258679a6471f.jpeg",
    "https://cdn.faire.com/fastly/16160d7df73747856795cbea3067e384e4e15a21f820906613428e8b7ad849b9.jpeg",
    "https://cdn.faire.com/fastly/57213ef7ce335ba04ca985d5fea621ab95a3325c06059a74cd3efac66dfb6718.jpeg",
    "https://cdn.faire.com/fastly/8109629bcf1f58a86c81700ca681b1a25d719c4b95aa859ef8f0c7f8c0ae9061.jpeg",
    "https://cdn.faire.com/fastly/d25cfbe114a0b7e89805f4b5f628c02fb82fa4e980eeca78953e7c7b12087685.jpeg",
    "https://cdn.faire.com/fastly/4420f192f0e955d4cd2f1bcfb0f0626d9994cb4ec3e1be6213215d7c25b3972c.jpeg",
    "https://cdn.faire.com/fastly/7d42d96839cb629701e148f675de7137b5065666927c914681b56f92c5b474f9.jpeg",
    "https://cdn.faire.com/fastly/9172769c891208868d2171c03a19ee0bcbc840ac460146962ec6ff7cb26a7bfb.jpeg",
    "https://cdn.faire.com/fastly/10230d53dd9fe57f09074b08e7b1869ee620712612baa8c53d4360d7a00a85b2.jpeg",
    "https://cdn.faire.com/fastly/f6f03e53398a779a4dc57b5dc65bae3bf1a758bc6a7bcea80bbf94dc26356697.jpeg",
    "https://cdn.faire.com/fastly/7a0e0342624b4c440a469dea1a1eec0dccee797f050fd818b0067390d7814312.jpeg",
    "https://cdn.faire.com/fastly/4bad1e7b931f54812782d5e274a48eb0b933007d47e9fbdf9e7c781ed93ce03b.jpeg",
  ],
  priceDollars: 7,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nA fun, flirty addition to the Hugger group. Just like the original, this style includes a light silicone grip along the sole for easy, stay-put wear. The crew length and ruffled ankle bring a soft, playful finish—perfect for pairing with flats, clogs, or slides.\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n85 Cotton 13 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\nMSRP: $16 USD",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:58.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
